import React, { Component } from "react";
import { make_request } from "../../Utils/Utils";
const subscribe_recaptcha_ref = React.createRef();

class CarouselEdition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editionId: this.props.editionId
    };
  }

  currentEdition = () =>
  {
    this.props.loadEdition(this.state.editionId)
  }

  render() {
    return (
      <div className={ this.props.active ? "row active" : "row slider_box"}>
        <div className="col-6">
          <h5> {this.props.year} </h5>
          <p> {this.props.editionName} </p>
        </div>
        <div className="col-6">
          <p className="mt-2">
            {" "}
            <a href='javascript:void(0)' onClick={this.currentEdition}> View Winners > </a>{" "}
            {/* <a onClick={this.props.loadEdition(this.props.editionId)}> View Winners > </a>{" "}  */}
          </p>
        </div>
      </div>
    );
  }
}
export default CarouselEdition;
